import React, { useEffect, useState } from 'react'
import { ChevronUp, ChevronDown, Trash, Pencil, Copy, Edit } from 'lucide-react'
import { Section, SectionTitle, GeneralList, SectionHeader, Button, SectionContent, Text, TextLight, SectionCardItem, CardTitle, CardHeader, ButtonIcons, IconButton, ObsDiv } from '../style'
import axios from '../../../../config/axios'
import { useSearchParams } from 'react-router-dom'

interface Stage {
  id: number
  name: string
  isSelected: boolean
  savedId?: number
}

// Interface para os dados que vêm do backend quando há stages salvos
interface SavedStageData {
  id: number
  serviceId: number
  stageId: number
  completed: boolean
  index: number
  description?: string
  observation?: string
  stage: {
    name: string
    id: number
  }
}

interface ShowServicesProps {
  setModalActive: React.Dispatch<React.SetStateAction<number | null>>
  refresh: boolean
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>
  setServiceToEdit: React.Dispatch<React.SetStateAction<any>>
}

const ShowServices = ({ setModalActive, refresh, setRefresh, setServiceToEdit }: ShowServicesProps) => {
  const [serviceStages, setServiceStages] = useState<SavedStageData[]>([])
  const [searchParams] = useSearchParams()
  const id = searchParams.get('id')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const fetchServiceStages = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/pcp/services-of-op/${id}`)
        setServiceStages(response.data || [])
        if (response.data && response.data.length > 0) {
          const firstIncompleteIndex = response.data.findIndex((stage: SavedStageData) => !stage.completed)
        }
      } catch (error) {
        console.error('Erro ao buscar stages salvos:', error)
        setServiceStages([])
      }
    }
    fetchServiceStages()
  }, [id, refresh])

  const handleEditService = (id: number) => {
    const serviceToEdit = serviceStages.find(stage => stage.id === id)
    if (serviceToEdit) {
      setServiceToEdit({
        id: serviceToEdit.id,
        stageId: serviceToEdit.stageId,
        name: serviceToEdit.stage.name,
        description: serviceToEdit.description || '',
        observation: serviceToEdit.observation || '',
        image: null
      })
    }
    setModalActive(1)
  }
  const handleCopyService = async (stageId: number) => {
    try {
      console.log(stageId)
      const response = await axios.patch(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service/duplicate-stage/${id}`, {stageId: stageId})
      if(response.data) {
        setRefresh(!refresh)
      }
    }catch (error) {
      console.log(error)
    }
  }
  const handleDelete = async (id: number) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/pcp/delete-stage/${id}`)
      if (response.data) {
        setRefresh(!refresh)
      }
    } catch (error) {
      console.log(error)
    }
    setRefresh(!refresh)
  }

  const handleMoveIt = async (id: number, direction: 'up' | 'down') => {
    const currentIndex = serviceStages.findIndex(stage => stage.id === id)
    const newIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1
    if (newIndex < 0 || newIndex >= serviceStages.length) return
    const servicesStages = serviceStages.map(stage => stage)
    const serviceStage = servicesStages[currentIndex]
    servicesStages.splice(currentIndex, 1)
    servicesStages.splice(newIndex, 0, serviceStage)
    try {
      const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/pcp/move-stage`, { servicesStages: servicesStages.map((stage, index) => ({ id: stage.id, index })) })
      if (response.data) {
        setServiceStages(servicesStages.map((stage, index) => ({ ...stage, index })))
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>Serviços</SectionTitle>
        <Button onClick={() => {
          setServiceToEdit(null)
          setModalActive(1)
        }}>Adicionar Serviço</Button>
      </SectionHeader>
      {serviceStages.length > 0 ?
        <SectionContent style={{ marginTop: '1rem' }} isEmpty={false} isLoading={isLoading}>
          <GeneralList>
            {serviceStages.map((stage) => (
              <SectionCardItem key={stage.id}>
                <CardHeader>
                  <CardTitle>{stage.stage.name} #0{(stage.index + 1) * 10}</CardTitle>
                  <ButtonIcons>
                  <IconButton onClick={() => handleDelete(stage.id)} colors='rgba(220, 38, 38, '><Trash size={16} /></IconButton>
                  <IconButton onClick={() => handleCopyService(stage.id)} colors='rgba(220, 38, 38, '><Copy size={16} /></IconButton>
                  <IconButton onClick={() => {
                    setServiceToEdit({
                      id: stage.id,
                      stageId: stage.stageId,
                      name: stage.stage.name,
                      description: stage.description || '',
                      observation: stage.observation || '',
                      image: null
                    })
                    setModalActive(1)
                  }} colors='rgba(220, 38, 38, '><Edit size={16} /></IconButton>
                    {/* <IconButton onClick={() => handleEditService(stage.id)} colors='rgba(38, 38, 220, '><Pencil size={16} /></IconButton> */}
                    <IconButton className={`${stage.index === 0 ? 'disabled' : ''}`} onClick={() => handleMoveIt(stage.id, 'up')} colors='rgba(202, 138, 4, '><ChevronUp size={16} /></IconButton>
                    <IconButton className={`${stage.index === serviceStages.length - 1 ? 'disabled' : ''}`} onClick={() => handleMoveIt(stage.id, 'down')} colors='rgba(202, 138, 4, '><ChevronDown size={16} /></IconButton>
                  </ButtonIcons>
                </CardHeader>
                <p>{stage.description}</p>
                <ObsDiv>
                  <p className='title'>Observações:</p>
                  <p>{stage.observation}</p>
                </ObsDiv>
              </SectionCardItem>
            ))}
          </GeneralList>
        </SectionContent>
        :
        <SectionContent isEmpty={true} isLoading={isLoading}>
          <Text>Nenhum serviço programado</Text>
          <TextLight>{'Clique em "Adicionar Serviço" para começar'}</TextLight>
        </SectionContent>
      }
    </Section>
  )
}

export default ShowServices
